<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4  float-left">Lista Unidades</p>
          <a (click)="createUnity()" class="btn btn-success float-right">
            Crear Unidades</a
          >
        </div>
        <div class="card-body">
          <table
            class="table table-bordered table-hover table-responsive-sm table-sm table-md "
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Abreviación</th>
                <!--                <th>Habilitado</th>-->
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let unity of unitys; let i = index">
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>{{ unity.nombre }}</td>
                <td>{{ unity.abreviado }}</td>

                <!--   <td>
                <label
                  class="switch switch_type1"
                  role="switch"
                  *ngIf="product.habilitado == true"
                >
                  <input
                    type="checkbox"
                    class="switch__toggle"
                    (click)="enableUser(product.id)"
                    checked="false"
                  />
                  <span class="switch__label"></span>
                </label>
                <label
                  class="switch switch_type1"
                  role="switch"
                  *ngIf="product.habilitado == false"
                >
                  <input
                    type="checkbox"
                    class="switch__toggle"
                    (click)="enableUser(product.id)"
                  />
                  <span class="switch__label"></span>
                </label>
              </td>-->
                <td>
                  <button
                    type="button"
                    class="btn btn-default btn-lg"
                    (click)="editModal(unity.unidad_id)"
                  >
                    <i
                      class="fa fa-pencil-square-o text-info"
                      style="font-size: 25px"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
